import { useTranslation } from 'next-i18next';
import { getAmount, getCurrencySymbol } from '../../../../utils/currencyHelper';
import { Price } from './RenderPrice.styles';

export function RenderPrice({
  price,
  currency,
  displayPriceAsIs = false,
  index,
  isPDP,
}: {
  price: number;
  currency: string | undefined;
  displayPriceAsIs?: boolean;
  index?: number;
  isPDP?: boolean;
}) {
  const { t } = useTranslation(['lib-global-common']);
  const priceDisplay = displayPriceAsIs ? price?.toFixed(2) : getAmount(price);
  const dataTestId = isPDP ? 'pdpDeliveryPrice' : 'cartDeliveryPrice';

  return (
    <Price data-testid={index !== undefined ? `${dataTestId}-${index + 1}` : dataTestId}>
      {price === 0 ? `${t('cart.free')}` : `${getCurrencySymbol(currency)}${priceDisplay}`}
    </Price>
  );
}
